"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapWithProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMonetize = require("react-monetize");

var wrapWithProvider = function wrapWithProvider(_ref, pluginOptions) {
  var element = _ref.element;
  return /*#__PURE__*/_react.default.createElement(_reactMonetize.MonetizeProvider, {
    paymentPointer: pluginOptions.paymentPointer
  }, element);
};

exports.wrapWithProvider = wrapWithProvider;